import { ReactElement } from "react";
import Lottie from "lottie-react";
import { AnimationType } from "./types";
import { useSpinner } from "./use-spinner";

interface DraycirSpinnerProps {
  width?: string;
  height?: string;
  animationType?: AnimationType;
}

/*
 * Displays a spinner
 */
const DraycirSpinner = ({ width, height, animationType }: DraycirSpinnerProps): ReactElement => {
  const spinner = useSpinner(animationType || "expanding");

  if (!spinner) return <></>;
  return <Lottie animationData={spinner} title='Draycir Spinner' width={width} height={height} />;
};

DraycirSpinner.defaultProps = {
  width: undefined,
  height: undefined,
  animationType: "expanding",
};

export default DraycirSpinner;
